import { useSuspenseQuery } from '@tanstack/react-query';

import { rsimProductDetailsQueries } from 'src/rSimInventory/Details/utils/rsimProductDetailsQueries';
import { fetchRSimsLastPollingTimestamps } from 'src/rSimInventory/RSimApi/rSimApi';

export const useRSimLastPoolingTimestamp = (euicc: string) => {
  return useSuspenseQuery({
    queryKey: rsimProductDetailsQueries.lastPolling(euicc),
    queryFn: async () => {
      const lastPollingTimestamps = await fetchRSimsLastPollingTimestamps([euicc]);
      return lastPollingTimestamps;
    },
    select: (timestamps) => {
      return timestamps?.[0] ?? null;
    },
  });
};
